import React, { useState, useEffect, useContext } from 'react';
import { checkString } from '../../helpers/global'
import Context from "../../context/context";
import Performance from './Performance';
import BookingLink from './BookingLink';

const Performances = props => {

  const { data, hash } = props;
  const { activeFilters } = useContext(Context);
  let performances = [];
  let filter_value = "";
  if (typeof activeFilters['top_filter'] !== "undefined") {
    filter_value = activeFilters['top_filter'].value;
  }

  if (filter_value !== "" || filter_value !== "all") {
    if (typeof data.performances[filter_value] !== 'undefined') {
      data.performances[filter_value].forEach((p) => {
        performances.push(<Performance data={p} />)
      })
    }
  }
  if (!data.ticket_free && data.priority_booking) {
    if (performances.length && filter_value !== "all") {
      return (
        <div className="performances">
          {performances}
        </div>
      )
    }
    else if (checkString(data.book_link)) {
      if (data.book_link === 'no-link' || data.ticket_free || !data.priority_booking) {
        return null
      }
      else {
        return (
          <a className="button button-black" href={data.book_link}>
            Find and book tickets
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
              <title>Find and book tickets</title>
              <path class="fill-bg" d="M0.300781 0H12.3008V12H0.300781V0Z" fill="black" />
              <path class="fill" d="M0.300781 0V-1H-0.699219V0H0.300781ZM12.3008 0H13.3008V-1H12.3008V0ZM12.3008 12V13H13.3008V12H12.3008ZM0.300781 12H-0.699219V13H0.300781V12ZM0.300781 1H12.3008V-1H0.300781V1ZM11.3008 0V12H13.3008V0H11.3008ZM12.3008 11H0.300781V13H12.3008V11ZM1.30078 12V0H-0.699219V12H1.30078Z" fill="black" />
              <path class="stroke" d="M4.72882 3.17157L7.55724 6L4.72882 8.82843" stroke="white" stroke-width="1.5" />
            </svg>
          </a>
        )
      }
    }
    else {
      return <BookingLink url={data.url} hash={hash} />
    }
  }

}

export default Performances;
